<ion-app>
  <ion-router-outlet [animated]="false"></ion-router-outlet>

  <app-check-appversion></app-check-appversion>
</ion-app>
